import React from "react";
import Header from "../../components/Header";
import AllPosts from "../../components/AllPosts";
import { useEffect } from "react";

export default function Home() {

  document.title = "Home";

  useEffect(() => {
    
    document.title = "Secret Corner";
  }, []);

  return (
    <>
      <Header/>
      <AllPosts/>
    </>
  );
}
